<template>
  <v-stepper v-model="currentStep" vertical fluid>
    <v-stepper-step step="1" v-bind:complete="selectedStep > 1" :editable="selectedStep <= 1">
      Website — Current State
      <small v-if="currentStep === 1">1.0</small>
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-card color="grey darken-3" class="white--text">
        <v-card-title primary-title>
          <div>
            <!--<h3 class="headline mb-0">Kangaroo Valley Safari</h3>-->
            <div>This release will include a website with browsable and downloadable addons.</div>
            <div>Developers will also be able to upload their plugins to the website to add it to the database.</div>
          </div>
        </v-card-title>
      </v-card>
    </v-stepper-content>

    <v-stepper-step step="2" v-bind:complete="selectedStep > 2" :editable="selectedStep <= 2">
      Cross-platform helper application
      <!--<small v-if="currentStep === 2">Current step</small>-->
    </v-stepper-step>
    <v-stepper-content step="2">
      <v-card color="grey darken-3" class="white--text">
        <v-card-title primary-title>
          <div>
            <!--<h3 class="headline mb-0">Kangaroo Valley Safari</h3>-->
            <div>This release will include a cross-platform application that will run in background on your computer.
            </div>
            <div>It will allow developers to push their plugin to the database in command line (an API should also be
                 available)
            </div>
            <div>Regular users will be able to auto-install their plugins with the app.</div>
          </div>
        </v-card-title>
      </v-card>
    </v-stepper-content>

    <v-stepper-step step="3" v-bind:complete="selectedStep > 3" :editable="selectedStep <= 3">
      Account features
      <!--<small v-if="currentStep === 3">Current step</small>-->
    </v-stepper-step>
    <v-stepper-content step="3">
      <v-card color="grey darken-3" class="white--text">
        <v-card-title primary-title>
          <div>
            <!--<h3 class="headline mb-0">Kangaroo Valley Safari</h3>-->
            <div>You will be able to link the website to your account and the app on your computer.</div>
            <div>We can then enable account synchronization:</div>
            <div>- Install addons straight from the website</div>
            <div>- Backup your addon list</div>
          </div>
        </v-card-title>
      </v-card>
    </v-stepper-content>

    <v-stepper-step step="4" v-bind:complete="selectedStep > 3" :editable="selectedStep <= 4">
      Construct 3 integration
      <!--<small v-if="currentStep === 4">Current step</small>-->
    </v-stepper-step>
    <v-stepper-content step="4">
      <v-card color="grey darken-3" class="white--text">
        <v-card-title primary-title>
          <div>
            <!--<h3 class="headline mb-0">Kangaroo Valley Safari</h3>-->
            <div>When Scirra will release his Editor SDK, this will hopefully allow us to create a custom editor plugin
                 of the form of an in-app addon manager
            </div>
          </div>
        </v-card-title>
      </v-card>
    </v-stepper-content>

  </v-stepper>
</template>

<script>

  export default {
    name: 'roadmap',
    data () {
      return {
        // Just to know where user click
        currentStep: 1,

        // At which point are we ?
        selectedStep: 0
      };
    },
    mounted () {
      this.selectedStep = 1;
    },
    components: {}
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Roadmap.vue